/** @module Specification/BOM/ProductSupplierSwitchboard */
define([
	"dojo/_base/declare",
	"csi",
	"csi/config",
	"csi/toolbar/MultiSelectSwitchboard",
], function(declare, csi, config, MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		bAutoSelectIfOne: true,
		bForceQuery: true,
		disableButtonAction: true,
		idViewProperty: "selectedProductSuppliers",
		switchboardPath: "Child:__Parent__/Child:__Parent__/Child:ProductSourcing/Child:ProductSources",

		/**
		 * Returns a boolean based on the number of product suppliers in the store or if ForProductSource is set on the ApparelBOM.
		 * @return {boolean} - whether or not to show dropdown to select product suppliers
		 */
		canShowPlugin: function() {
			var ctx = this.getView().getContext();
			var bomSupplier = ctx.defView.findHeading("BOMSupplierAttributes");
			var bomRev = ctx.getParent();
			var bom = ctx.getNodeParent(bomRev);
			var exposeBOM = config.getNodeSetting(bom, "ExposeBOMSupplierAttributes");

			return bomSupplier && exposeBOM &&
				bom.ForProductSource == csi.EMPTY_URL &&
				this.store && this.store.isLoaded() && this.store.query().length > 1;
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});
});